import { useFormikContext } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { FormSection } from '@@/form-components/FormSection';

import { KubernetesSecurityFormValues } from './types';

export function PodSecurityConstraintsSection() {
  const { values, setFieldValue } =
    useFormikContext<KubernetesSecurityFormValues>();

  return (
    <FormSection title="Pod security constraints">
      <FormControl
        inputId="enable-pod-security-constraints"
        label="Enable pod security constraints"
        size="large"
      >
        <Switch
          id="enable-pod-security-constraints"
          data-cy="enable-pod-security-constraints-toggle"
          name="enablePodSecurityConstraints"
          className="space-right"
          checked={values.enablePodSecurityConstraints || false}
          onChange={(value) =>
            setFieldValue('enablePodSecurityConstraints', value)
          }
        />
      </FormControl>
    </FormSection>
  );
}
